import styled from 'styled-components';
import { MarkersMap } from '../../constants';
import DefaultMarker from './icons/DefaultMarker';
import { MapMarkerType } from '../../types';
import { useSelector } from 'react-redux';
import useMapHelpers from '../../hooks/MapHelpers';
import { useRouter } from 'next/router';
import AreaMarker from './AreaMarker';
import ClusterMarker from './ClusterMarker';

interface CustomMarkerProps {
  id: number;
  name: string;
  type: MapMarkerType;
  category: 'compound' | 'area' | 'cluster';
  index: number;
  clusterCount?: number;
  isFiltered?: boolean;
}

const CustomMarker = ({
  id,
  name,
  type,
  category,
  index,
  clusterCount,
  isFiltered
}: CustomMarkerProps) => {
  const { locale } = useRouter();
  const firstDestination = useSelector(
    (state: any) => state.map.firstDestination
  );
  const secondDestination = useSelector(
    (state: any) => state.map.secondDestination
  );
  const MarkerComponent = MarkersMap.get(type);
  const { shouldShowCompound } = useMapHelpers();
  if (category == 'area') {
    return <AreaMarker id={id} name={name} />;
  }
  if (category == 'cluster') {
    return (
      <ClusterMarker
        name={name}
        clusterCount={clusterCount}
        isFiltered={isFiltered}
      />
    );
  }
  if (!MarkerComponent) {
    return <DefaultMarker />;
  }
  return (
    <Container locale={locale}>
      <MarkerComponent />

      {(shouldShowCompound(index) ||
        id === firstDestination?.id ||
        id === secondDestination?.id) && <span className="name">{name}</span>}
    </Container>
  );
};

const Container = styled.div<{
  locale: string | undefined;
}>`
  width: fit-content;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 8px;
  justify-content: center;
  overflow: hidden;

  span {
    position: absolute;
    top: -30px;
    font-size: 12px;
    font-family: materialMedium;
    color: black;
    z-index: 99999999999999;
    white-space: nowrap;
    background-color: #fff;
    padding: 4px 8px;
    border-radius: 8px;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    overflow-x: visible;
    margin-top: unset;
    overflow-x: visible;
    gap: 16px;
  }
`;

export default CustomMarker;
